<template>
    <div class="dashboard-item-menu-container">
        <div class="title-container"
             :style="{'background-color': titleBackgroundColor, 'color': titleColor}">
            <p class="dashboard_item_menu_title" :style="threatScoreMenu ? {'font-size': '1.375em'} : null">{{title}}</p>
            <img :src="customerAvatar" class="avatar" v-if="customerAvatar && customerAvatar !== 'None'" style="width: 50px; height: 50px;" :style="threatScoreMenu ? {'margin-left': '70%'} : null">
        </div>
        <div class="menu-container">
            <div class="menu-container-scroll" ref="menuContainerScroll" :style="{'width': 'calc(100% + ' + getScrollbarWidth + 'px)'}">
                <div class="menu-container-scroll-overlay"></div>
                <div class="menu" v-for="menu in menuList" v-bind:key="menu.text + Date.now()">
                    <div class="menu-title-container"
                         @click="onMenuTitleClick(menu)"
                         :style="{'color': menu.color, 'background-color': menu.backgroundColor}">
                        <p class="menu-title">{{menu.text}}</p>
                        <img class="dropdown-icon menu-title-arrow" v-if="menu.type == 'dropdown'"
                             :class="{'menu-title-arrow-rotated' : !menu.open}"
                             :style="{'right' : (getScrollbarWidth == 0 ? 15 : getScrollbarWidth) + 'px'}"
                             src="../../assets/menu-arrow.svg"
                             width="15px">
                    </div>
                    <div class="menu-item-container" v-if="menu.open">
                        <div class="menu-item" v-for="item in menu.items" @click="onMenuItemClick(item, menu)" v-bind:key="item.id">
                            <p class="item-text" :style="{'color': item.selected ? item.selectedColor ? item.selectedColor : menu.backgroundColor : item.color}">{{item.text}}</p>
                            <div class="menu-item-progress-container" v-if="item.progress">
                                <div class="menu-item-progress" :style="{'background-color' : item.progressColor, 'width' : item.progress + '%'}"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import {mapGetters} from 'vuex';

    export default {
        name: "dashboard-item-menu",
        props: {
            threatScoreMenu: {
                type: Boolean,
                required: false,
                default: false
            },
            titleColor: {
                type: String,
                required: true
            },
            titleBackgroundColor: {
                type: String,
                required: true
            },
            title: {
                type: String,
                required: true
            },
            menuList: {
                type: Array,
                required: true
            },
            customerAvatar: {
                type: String,
                required: false
            }
        },
        data() {
            return {
                hasScrollbar: false
            }
        },
        methods: {
            onMenuTitleClick(menu) {
                if (menu.type == 'dropdown')
                    menu.open = !menu.open;
                this.$nextTick(this.checkHasScrollbar);
            },
            onMenuItemClick(item, menu) {
                if (menu.type != 'dropdown' && menu.type != 'selectableProgress') return;
                if (item.selected) return;
                for (let i = 0; i < menu.items.length; i++) {
                    menu.items[i].selected = false;
                }
                item.selected = true;

                if (menu.type == 'dropdown') {
                    menu.text = item.text;
                    menu.open = !menu.open;
                }

                // send event to parent
                this.$emit("menuItemClicked", item);
            },
            checkHasScrollbar() {
                var elem = this.$refs.menuContainerScroll;

                if (!elem) return false;

                this.hasScrollbar = elem.scrollHeight > elem.clientHeight;
            }
        },
        computed: {
            ...mapGetters([
                "getScrollbarWidth"
            ])
        }

    }
</script>

<style scoped>
    .title-container img{
        margin-left: 60%;
        margin-top: 10%;
    }


    .dashboard-item-menu-container {
        width: 100%;
        height: 100%;
        padding: 0;
        overflow: hidden;
    }

    .title-container {
        width: 100%;
        height: 120px;
    }

    .menu-container {
        height: calc(100% - 120px);
        width: 100%;
        overflow: hidden;
        box-sizing: content-box;
    }

    .menu-container-scroll {
        /*width: calc(100% + 15px);*/
        height: 100%;
        overflow-y: scroll;
        overflow-x: hidden;
        /*padding-right: 15px; !*This would hide the scroll bar of the right. To be sure we hide the scrollbar on every browser, increase this value*!*/
        box-sizing: content-box;
        position: relative;
    }

    .menu-container-scroll-overlay {
        position: absolute;
        top:0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: black;
    }

    .dashboard_item_menu_title {
        width: 75%;
        font-family : 'Digital-Serial-Bold';
        font-size: 0.875em;
        padding-left: 10%;
        padding-top:10%;
        -webkit-touch-callout: none; /* iOS Safari */
        -webkit-user-select: none; /* Safari */
        -khtml-user-select: none; /* Konqueror HTML */
        -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
        user-select: none;
        white-space:pre-wrap;
    }

    .menu-title-container {
        width: 100%;
        height: 60px;
        cursor: pointer;
        position: relative;
    }

    .menu-title {
        font-family : 'Digital-Serial-Bold';
        font-size: 0.875em;
        padding-left: 20px;
        line-height: 60px;
        display: inline-block;
        -webkit-touch-callout: none; /* iOS Safari */
        -webkit-user-select: none; /* Safari */
        -khtml-user-select: none; /* Konqueror HTML */
        -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
        user-select: none;
    }

    .menu-title-arrow {
        -webkit-touch-callout: none; /* iOS Safari */
        -webkit-user-select: none; /* Safari */
        -khtml-user-select: none; /* Konqueror HTML */
        -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
        user-select: none;
    }

    .menu-title-arrow-rotated {
        -webkit-transform: rotate(-90deg);
        -moz-transform: rotate(-90deg);
        -ms-transform: rotate(-90deg);
        -o-transform: rotate(-90deg);
        transform: rotate(-90deg);
    }

    .menu-item-container {
        width: 100%;
        position: relative;
        margin-top: 4%;
    }

    .menu-item {
        font-family : 'Digital-Serial-Bold';
        font-size: 0.875em;
        padding-left: 10%;
        height: 40px;
        line-height: 40px;
        margin: 0;
        cursor: pointer;
        -webkit-touch-callout: none; /* iOS Safari */
        -webkit-user-select: none; /* Safari */
        -khtml-user-select: none; /* Konqueror HTML */
        -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
        user-select: none;
        position: relative;
    }

    .dropdown-icon {
        position: absolute;
        top:0;
        bottom:0;
        margin:auto;
    }

    .menu-item p {
        width: 90%;
        overflow: hidden;
    }

    .menu-item-progress-container {
        height: 3px;
        width: 80%;
        position:absolute;
        top:30px;
        left: 10%;
        right:10%;
    }

    .menu-item-progress {
        height: 100%;
        width: 20%;
    }

    .item-text {
        height: 40px;
        overflow: hidden;
    }

</style>



// WEBPACK FOOTER //
// src/components/menu/DashboardItemMenu.vue